module.exports = __webpack_public_path__ + "assets/img/healthcareSolutions-management.fa34699b.png";